import { render, staticRenderFns } from "./SchoolChart.vue?vue&type=template&id=0827f7b8&"
import script from "./SchoolChart.vue?vue&type=script&lang=js&"
export * from "./SchoolChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports